export { createMetaDescriptionForProperty } from './createMetaDescriptionForProperty';
export { createMetaTitleForProperty } from './createMetaTitleForProperty';
export { defineMetaTitlesForCountry } from './defineMetaTitlesForCountry';
export { defineMetaTitlesForManagerPage } from './defineMetaTitlesForManagerPage';
export { defineMetaTitlesForPropertyType } from './defineMetaTitlesForPropertyType';
export { defineRealEstatePageAlternates } from './defineRealEstatePageAlternates';
